import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../home/Home";
import Projects from "../projects/Projects";
import Career from "../career/Career";
import Contact from "../contact/Contact";
import AllProjectRoutes from "./AllProjectRoutes"; // Make sure this import points to the correct file

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/career" element={<Career />} />
      <Route path="/contact" element={<Contact />} />
      {/* Spread in the individual project detail routes */}
      {AllProjectRoutes}
    </Routes>
  );
};

export default AllRoutes;
